var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(!_vm.online)?_c('div',{staticClass:"text-center text-xs py-1 text-white bg-stone-900"},[_vm._v(" اتصالتان به اینترنت را بررسی کنید "),_c('v-icon',{attrs:{"color":"#fff"}},[_vm._v("mdi-wifi")])],1):_vm._e(),_c(_vm.layout,{tag:"component"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }